<div [formGroup]="form" class="flex justify-between items-center py-2 w-full">
  <div class="flex justify-between items-center w-10/12 gap-4">
    <mat-form-field class="input-tg w-5/12" appearance="outline">
      <mat-label>Tipo Documento</mat-label>
      <mat-select formControlName="docType">
        @for (type of listType; track type) {
        <mat-option [value]="type">{{ type.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="input-tg flex w-5/12" appearance="outline">
      <mat-label>Descrição</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>
    <div class="flex w-5/12">
      <input hidden type="file" (change)="onFileSelected($event)" #fileInput [accept]="getAllowedTypes()" />
      <mat-form-field class="input-tg input-btn-icon w-full" appearance="outline">
        <mat-label>Arquivo</mat-label>
        <input matInput formControlName="file" [value]="fileName" readonly />
        <button mat-icon-button matSuffix (click)="fileInput.click()">
          <mat-icon>upload</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
  <div class="flex items-center justify-end mb-5">
    <button mat-button class="btn-tg" (click)="addDocument()" [disabled]="form.invalid">Adicionar</button>
  </div>
</div>